import { Title, Text, Button, Container, Group } from '@mantine/core';
import { Link } from 'react-router-dom';
import classes from './error-page.module.css';

interface ErrorPageProps {
  message: string;
}
function ErrorPage({ message }: ErrorPageProps) {
  return (
    <Container className={classes.root}>
      <div className={classes.label}>sorry</div>
      <Title className={classes.title}>You found an error</Title>
      <Text c="dimmed" size="lg" ta="center" className={classes.description}>
        Please let us know and we will get someone on it!
      </Text>
      <Text c="dimmed" size="lg" ta="center" className={classes.description}>
        <i>{message}</i>
      </Text>
      <Group justify="center">
        <Button variant="subtle" size="md" component={Link} to="/">
          Take me back to home page
        </Button>
      </Group>
    </Container>
  );
}

export default ErrorPage;
